import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityPrimitiveColorTokens } from '../unityTokens';

type EventColors = NonNullable<PaletteOptions['events']>;

export const unityEventColorsLight: EventColors = {
  unknown: { color: unityPrimitiveColorTokens['--color-accent-palatinate-blue-400'] },
  group: { color: unityPrimitiveColorTokens['--color-charcoal-400'] },
  broadcasts: { color: unityPrimitiveColorTokens['--color-accent-pink-flamingo-600'] },
  deploys: { color: unityPrimitiveColorTokens['--color-accent-sky-blue-600'] },
  featureFlags: { color: unityPrimitiveColorTokens['--color-purple-500'] },
  alerts: { color: unityPrimitiveColorTokens['--color-accent-persimmon-500'] },
  infrastructure: { color: unityPrimitiveColorTokens['--color-accent-turquoise-600'] },
  thirdParty: { color: unityPrimitiveColorTokens['--color-accent-sushi-green-500'] },
  chronosphere: { color: unityPrimitiveColorTokens['--color-brand-800'] },
  perfTests: { color: unityPrimitiveColorTokens['--color-accent-palatinate-blue-400'] },
  annotations: { color: unityPrimitiveColorTokens['--color-green-400'] },
};

export const unityEventColorsDark: EventColors = {
  unknown: { color: unityPrimitiveColorTokens['--color-accent-palatinate-blue-300'] },
  group: { color: unityPrimitiveColorTokens['--color-charcoal-300'] },
  broadcasts: { color: unityPrimitiveColorTokens['--color-accent-pink-flamingo-500'] },
  deploys: { color: unityPrimitiveColorTokens['--color-accent-sky-blue-500'] },
  featureFlags: { color: unityPrimitiveColorTokens['--color-purple-400'] },
  alerts: { color: unityPrimitiveColorTokens['--color-accent-persimmon-400'] },
  infrastructure: { color: unityPrimitiveColorTokens['--color-accent-turquoise-500'] },
  thirdParty: { color: unityPrimitiveColorTokens['--color-accent-sushi-green-400'] },
  chronosphere: { color: unityPrimitiveColorTokens['--color-brand-700'] },
  perfTests: { color: unityPrimitiveColorTokens['--color-accent-palatinate-blue-300'] },
  annotations: { color: unityPrimitiveColorTokens['--color-green-300'] },
};

export const eventColorsLight: EventColors = {
  unknown: { color: '#7E93FF' },
  group: { color: '#8690B6' },
  broadcasts: { color: '#D5406D' },
  deploys: { color: '#438FEB' },
  featureFlags: { color: '#956DE9' },
  alerts: { color: '#FF763B' },
  infrastructure: { color: '#00BCA6' },
  thirdParty: { color: '#B0BF00' },
  chronosphere: { color: '#15C95D' },
  perfTests: { color: '#7E93FF' },
  annotations: { color: '#169553' },
};

export const eventColorsDark: EventColors = {
  unknown: { color: '#93A4FF' },
  group: { color: '#8690B6' },
  broadcasts: { color: '#FA5586' },
  deploys: { color: '#5E9FEE' },
  featureFlags: { color: '#A582ED' },
  alerts: { color: '#FF7E47' },
  infrastructure: { color: '#00CCB4' },
  thirdParty: { color: '#BCCC00' },
  chronosphere: { color: '#31E77A' },
  perfTests: { color: '#93A4FF' },
  annotations: { color: '#169553' },
};

export const events = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['events'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light' ? unityEventColorsLight : unityEventColorsDark;
  }

  return mode === 'light' ? eventColorsLight : eventColorsDark;
};
